import React, { useMemo } from 'react';
import ImageCarousel from '../ui/ImageCarousel';
import '../../styles/components/feature-cards.css';

const CinematicEffectsCard: React.FC = () => {
  const carouselImages = useMemo(() => [
    {
      src: 'https://odoxckqeovvymewxfvoi.supabase.co/storage/v1/object/public/post-images/carousel/filmgrain.jpg',
      alt: 'LUT Rolls app mockup'
    },
    {
      src: 'https://odoxckqeovvymewxfvoi.supabase.co/storage/v1/object/public/post-images/carousel/filmgrain2.jpg',
      alt: 'LUT Rolls app mockup'
    },
    {
      src: 'https://odoxckqeovvymewxfvoi.supabase.co/storage/v1/object/public/post-images/carousel/poster.jpg',
      alt: 'LUT Rolls app mockup'
    },
    {
      src: 'https://odoxckqeovvymewxfvoi.supabase.co/storage/v1/object/public/post-images/carousel/unfoldedphoto1.jpg',
      alt: 'LUT Rolls app mockup'
    },
    {
      src: 'https://odoxckqeovvymewxfvoi.supabase.co/storage/v1/object/public/post-images/carousel/vintage.jpg',
      alt: 'LUT Rolls app mockup'
    }
    // Add more images here as needed
  ], []);

  return (
    <div className="feature-card feature-card-layout">
      {/* Left: Image Carousel */}
      <div className="feature-card-image-container">
        <ImageCarousel
          images={carouselImages}
          autoplay={true}
          autoplayDelay={3000}
          pauseOnHover={true}
        />
      </div>

      {/* Right: Title and text (top-aligned) */}
      <div className="feature-card-content">
        <h2>Cinematic Effects</h2>
        <p style={{fontSize: '1.4rem', fontWeight: 500, lineHeight: 1.5, marginBlockEnd: '0.25em'}}>
          Cinematic grain, vintage textures, and atmospheric light leaks that replicate classic film photography. Each effect uses blend modes for natural, professional results that enhance your images without overpowering them.
        </p>
        <p style={{fontSize: '1.4rem', fontWeight: 500, lineHeight: 1.5, marginBlockEnd: '0.25em'}}>
          Use VHS aesthetics with holographic overlays or subtle paper textures for unique visual storytelling. Simple controls make professional-grade cinematic effects accessible to everyone, regardless of editing experience.
        </p>
      </div>
    </div>
  );
};

export default CinematicEffectsCard;
